import { Routes } from '@angular/router'

import { landingGuard, notAssignedGuard } from './modules/workspaces/guards/landing.guards'
import { OrganisationAdminRoutes } from './modules/workspaces/organisation-admin/organisation-admin-routes'
import { WorkspaceRoutes } from './modules/workspaces/workspace/new-workspace-routes'
import { workspaceAccessGuard } from './modules/workspaces/workspace/workspace.guards'
import type { RouteArea } from './shared/store/selectors/router.selectors'

export const AppGuardedRoutes: Routes = [
  // LANDING - the guard always redirects
  {
    path: '',
    pathMatch: 'full',
    canActivate: [landingGuard],
    children: [],
  },
  // The workspace picker it named is gone; old links and bookmarks land instead.
  {
    path: 'workspaces-select',
    canActivate: [landingGuard],
    children: [],
  },
  {
    path: 'not-assigned',
    canActivate: [notAssignedGuard],
    loadComponent: () =>
      import('./modules/workspaces/not-assigned/not-assigned.component').then(
        ({ NotAssignedComponent }) => NotAssignedComponent
      ),
  },

  // ORGANISATION ADMIN ROUTES
  // workspaces, fonts, designer users/roles, runtime users/roles/groups, task management, audit logs
  {
    path: 'organisation-admin',
    loadComponent: () =>
      import('./modules/workspaces/organisation-admin/organization-admin-main.component').then(
        ({ OrganizationAdminMainComponent }) => OrganizationAdminMainComponent
      ),
    data: { area: 'org' satisfies RouteArea },
    children: OrganisationAdminRoutes,
  },
  // WORKSPACE ROUTES
  // workspace entities: application/library, themes, fonts, media library, audit logs, users, groups
  {
    path: 'workspace/:workspaceId',
    data: { area: 'workspace' satisfies RouteArea },
    canActivate: [workspaceAccessGuard],
    children: WorkspaceRoutes,
  },

  // DESIGN SYSTEM SHOWCASE - not exposed in any menu, only for review purposes
  {
    path: 'design-system-showcase',
    loadComponent: () =>
      import('./modules/design-system-showcase/design-system-showcase.component').then(
        (m) => m.DesignSystemShowcaseComponent
      ),
  },
]
